let config = {
  SECURE_PROTOCOL: 'https',
  PROTOCOL: 'https',
  //URL: 'beta.api.sportzag.com',
  URL: 'dev1api.sportzag.com',
  API_URL: 'dev1api.sportzag.com',
  APP_URL: 'dev1app.sportzag.com',
  /* URL: 'localhost',
  API_URL: 'localhost', */
  IMAGE_URL: 'dev1platform.sportzag.com',
  PORT: 6604,
  SALT: 'Sportoco',
  IMAGE_FOLDER: 'image',
  MEDIA_BASE_URL: 'https://assets-dev1.sportzag.com/',
}

config.connectOptions = {
  hostname: config.URL,
  //path: '/socketcluster',
  ackTimeout: 90000,
  autoReconnect: true,
  autoReconnectOptions: {
    initialDelay: 3000,
    randomness: 100,
    multiplier: 1.75,
    maxDelay: 60000,
  },
  disconnectOnUnload: true,
  autoSubscribeOnConnect: true,
port: 443,
  secure: true,
}

config.firebaseConfig = {
  apiKey: 'AIzaSyDXHZJQ24Dv4RYvyUR7ViqvDtrp3rDKlAA',
//  authDomain: 'sportocoplayalong.firebaseapp.com',
  authDomain: 'auth.sportzag.com',
  projectId: 'sportocoplayalong',
  storageBucket: 'sportocoplayalong.appspot.com',
  messagingSenderId: '467185708403',
  appId: '1:467185708403:web:9862d3ab612657c4722906',
  measurementId: 'G-QSJ0VSTMR6',
} 

export default config



// WEBPACK FOOTER //
// src/Agent/config.js